module.exports = __webpack_public_path__ + "img/Socan.82a9b12e.svg";